export class mFavoriet {
    constructor(artikelNr: string, aantal: number) {
        this.Aantal = aantal;
        this.ArtikelNr = artikelNr;
    }
    public ArtikelNr: String;
    public Aantal: number;
}